export default "__VITE_ASSET__c95d121e__"